import { computed, Directive, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import type { Language } from '@valk-nx/core/lib/core';
import { cn, fallbackLanguage } from '@valk-nx/core/lib/core';

@Directive()
export abstract class BaseDirective {
	readonly translate = inject(TranslateService);

	cn = cn;

	readonly language = computed<Language>(
		() =>
			(this.translate.currentLang() ??
				this.translate.fallbackLang() ??
				fallbackLanguage) as Language,
	);
}
